import styles from '../products-add-new-product.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRootStore } from '../../../../mobx-stores/store-provider'
import {
  SectionContainer,
  H2,
  GalleryDropZone,
  Button,

  GalleryDropZoneRef,
  ProductSkuDTO,
  isLocalId,
} from '@touche-lts/panel-ui/dist'
import { IconEdit } from 'assets/icons'
import { useEffect, useState } from 'react'
import { StyleProps } from 'utilities'

interface ProductsImageSectionProps extends StyleProps {
  imageGalleryRef: GalleryDropZoneRef
  editMode: boolean
  productId: number | string
}

const ProductsImageSectionComponent = (props: ProductsImageSectionProps) => {
  const { className, style, imageGalleryRef, editMode, productId } = props,
    {
      productsImagesStore: {
        productInitialImagesStore,
        setProductImagesStoreProps,
        updateProductImages,
        // getAllProductSkus,
        // allProductSkus,
        analyzeAndUpdateSkuImages
      },
      generalStore: {
        api: { uploadFileSigned }
      },
      productsSKUsStore: { productSKUsAttributeStore },
      viewProductsPageStore: { store },
      productsSKUTableStore: {
        triggerSearch
      }
    } = useRootStore(),

    onCancelEditClick = () => {
      setEditModeSection(false)
    },

    onSaveClick = async () => {
      await imageGalleryRef.current.handleImages()
      const imagesWithLocalIds = imageGalleryRef.current
        .getImages({
          keepLocalIds: true
        })
        .filter(img => isLocalId(img.id))
      setProductImagesStoreProps(imageGalleryRef.current.getImages())

      const updatedImages = await updateProductImages(productId)

      await analyzeAndUpdateSkuImages({
        skusBefore: store.productSkus || ([] as any),
        skusAfter: imageGalleryRef.current.getProductSkus(),
        images: updatedImages,
        imagesWithLocalIds: imagesWithLocalIds,
        productId
      })
      setEditModeSection(false)
      if (editMode) triggerSearch({ resetPageNumber: true })
    },

    [editModeSection, setEditModeSection] = useState<boolean>(false)

  useEffect(() => {
    if (!editMode) setEditModeSection(true)
  }, [editMode])

  const imageGalleryKey = JSON.stringify(productInitialImagesStore?.map(img => img.id))
  return (
    <SectionContainer
      className={cl(className)}
      style={style}
      colorPreset='dark'
      extraPaddingBottom
    >
      <div className='d-flex justify-content-between'>
        <H2 className={styles.sectionHeadingWithButton} colorPreset='dark'>
          Image Gallery
        </H2>
        {editMode && !editModeSection && (
          <Button preset='icon' onClick={() => setEditModeSection(true)}>
            <IconEdit fill={styles.white} />
          </Button>
        )}
        {editMode && editModeSection && (
          <div className={styles.headingButtonsEditContainer}>
            <Button
              preset='secondary'
              colorPreset='dark'
              onClick={onCancelEditClick}
            >
              Cancel
            </Button>
            <Button preset='primary' onClick={onSaveClick}>
              Save
            </Button>
          </div>
        )}
      </div>

      {editModeSection ? (
        <GalleryDropZone
          key={imageGalleryKey}
          className={styles.upload}
          ref={imageGalleryRef}
          colorPreset='dark'
          initialImages={productInitialImagesStore}
          uploadFile={uploadFileSigned}
          attributeGroups={productSKUsAttributeStore}
          productSkus={((store?.productSkus || []) as ProductSkuDTO[])}
        />
      ) : (
        <div className={styles.wrapper}>
          <GalleryDropZone
            key={imageGalleryKey}
            ref={imageGalleryRef}
            colorPreset='dark'
            initialImages={productInitialImagesStore}
            uploadFile={uploadFileSigned}
            attributeGroups={productSKUsAttributeStore}
            productSkus={((store?.productSkus || []) as ProductSkuDTO[])}
          />
        </div>
      )}
    </SectionContainer >
  )
},

  ProductsImageSectionProduct = observer(ProductsImageSectionComponent)
export { ProductsImageSectionProduct }
